import React from "react";
import AdminGenericCRUDPage from "./AdminGenericCRUDPage";

const FIELDS = [
  { name: "slug",         label: "Slug (URL)", required: true,
    help: "Lowercase, kebab-case (ör: hb-dijital-baski)" },
  { name: "client",       label: "Müşteri", required: true },
  { name: "category",     label: "Kategori",
    help: "social, video, performance, youtube, creative" },
  { name: "year",         label: "Yıl", type: "number" },
  { name: "cover",        label: "Kapak Görseli", type: "image" },
  { name: "services",     label: "Hizmetler (JSON dizi)", type: "json", rows: 2,
    help: '["Meta Ads","SEO"]' },
  { name: "gallery",      label: "Galeri (JSON dizi)", type: "json", rows: 3,
    help: '["/works/01.jpg","/works/02.jpg"]' },
  { name: "translations", label: "İçerik Çevirileri (JSON)", type: "json", rows: 12,
    help: 'tr/en için { tr: { title, excerpt, challenge, approach, results, metrics:[{label,value}] } }' },
  { name: "order",        label: "Sıra", type: "number" },
];

export default function AdminWorksPage() {
  return (
    <AdminGenericCRUDPage
      title="Projeler"
      subtitle="Portfolyo case study'leri"
      endpoint="/admin/works"
      identifier="slug"
      fields={FIELDS}
      defaultItem={{
        slug: "", client: "", category: "social", year: 2025,
        cover: "", services: [], gallery: [],
        translations: { tr: { title: "", excerpt: "", challenge: "", approach: "", results: "", metrics: [] } },
        order: 99,
      }}
      testIdPrefix="works"
    />
  );
}
